import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Modal } from "react-bootstrap";
const ConfirmDialog = ({
  title,
  acceptAction,
  rejectAction,
  acceptText,
  rejectText,
  closePopup,
  note,
}) => {
  return (
    <Modal show={true} size="lg">
      <Modal.Header>
        <div className="modal-title">
          <h5 className="profile-title">Confirm</h5>
          <FontAwesomeIcon icon={faTimesCircle} onClick={closePopup} />
        </div>
      </Modal.Header>
      <Modal.Body>
        <p>{title}</p>
        <label className="note">{note && note}</label>
      </Modal.Body>
      <Modal.Footer>
        <div className="submit-section">
          <button
            className="btn-orange mr-4"
            onClick={() => {
              acceptAction();
              closePopup();
            }}
          >
            {acceptText}
          </button>
          <button
            className="btn-orange"
            onClick={() => {
              rejectAction && rejectAction();
              closePopup();
            }}
          >
            {rejectText}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDialog;
